import React from 'react';

import PasswordManager from './PasswordManager';

const SetPassword = () => <PasswordManager type="reset" />;
export default SetPassword;
